export default "__VITE_ASSET__Y4124zGk__"